import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ITab } from '@voxel/components';

import { RequestSolicitationsService } from '../../services/solicitations/request-solicitations.service';
import { ApplicationService } from '../../services/application/application.service';
import { VoxelTabsComponent } from '@voxel/components';
import { NavigationService } from '../../services/navigation/navigation-service.service';
import { BaseComponent } from '../base-component';
import { LinkupService } from '../../services/link-up/linkup.service';
import { centerDialog, getValueProperty, scrollTop, setValueProperty } from '../../helpers/functions.helpers';
import { EVENT } from '../../constants/dali.constants';
import { CopyService } from '../../services/copies/copy.service';

export enum EActionDialog {
  CANCEL = 'CANCEL',
  CONFIRM = 'CONFIRM'
}

/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})

/**
 * Clase del componente Header
 *
 * *Header component class*
 *
 * @implements {OnInit}
 */
export class HeaderComponent extends BaseComponent implements OnInit {

  @ViewChild("tabsComponent") tabsComponent!: VoxelTabsComponent;

  ACTIONS_DIALOG = EActionDialog;
  dialogShow = false;
  dialogChangeShow = false;
  CONTENT_BOUNDS: any[] | any;

  optionRequestSelected: boolean = true;

  /**
   * Declaración de la variable headerTitle como any, donde se registra el título del header
   *
   * *Set headerTitle variable as any, where it's saved the header title*
   *
   * @access              public
   * @type                {any}
   */
  @Input() headerTitle: any;

  /**
   * Declaración de la variable headerSubtitle como any, donde se registra el subtítulo del header
   *
   * *Set headerSubtitle variable as any, where it's saved the header subtitle*
   *
   * @access              public
   * @type                {any}
   */
  @Input() headerSubtitle: any;

  /**
   * Declaración de la variable currentStep como any, donde se registra el paso actual si aplica
   *
   * *Set currentStep variable as any, where it's saved the current step if it applies*
   *
   * @access              public
   * @type                {any}
   */
  @Input() currentStep: any;

  /**
   * Declaración de la variable amountSteps como any, donde se registra la cantidad de pasos de la pantalla si aplica
   *
   * *Set amountSteps variable as any, where it's saved the amount of step if it applies*
   *
   * @access              public
   * @type                {any}
   */
  @Input() amountSteps: any;

  /**
   * Declaración de la variable showSteps como boolean, donde se registra la validación para mostrar los pasos
   *
   * *Set showSteps variable as boolea, where it's saved the steps validation*
   *
   * @access              public
   * @type                {boolean}
   */
  @Input() showSteps = true;

  /**
   * Declaración de la variable showTitle como boolean, donde se registra la validación para mostrar el título de la página
   *
   * *Set showTitle variable as boolea, where it's saved close button validation*
   *
   * @access              public
   * @type                {boolean}
   */
  @Input() showTitle = false;

  /**
   * Variable que valida si se debe mostrar el botón cerrar o no
   *
   * *This variable validates if button close should be shown or not*
   */
  @Input() close = false;

  /**
   * Declaración de la variable isPreviousAvailable como boolean, donde se registra la validación para la pantalla anterior
   *
   * *Set isPreviousAvailable variable as boolea, where it's saved previous screen availability validation*
   *
   * @access              public
   * @type                {boolean}
   */
  // isPreviousAvailable: boolean;

  /**
   * Declaración de la variable icons como any, donde se registran los iconos del header
   *
   * *Set icons variable as any, where it's saved headers icons*
   *
   * @access              public
   * @type                {any}
   */
  icons: any = [];

  /**
   * Declaración de la variable headerClass, determina la clase que usara el header
   *
   * *Set class in header*
   *
   * @access              public
   * @type                {string}
   */
  headerClass = '';

  @Input() closeText: string = '';

  @Output() closeEvent = new EventEmitter();

  @Input()
  currentTab = 1;

  selectedTab = 1;

  tabs: ITab[] = [
    { name: 'Radicar solicitud', panelId: 'example-default-1' },
    { name: 'Consultar solicitud', panelId: 'example-default-2' },
  ];


  /**
   * Summary      Constructor of the component.
   *
   * @param {NavigationService}  navigationService  Injectable navigationService service.
   * @param {AbreCuentasService} abreCuentasService Injectable abreCuentasService service.
   */
  constructor(
    public app: ApplicationService,
    private readonly _solicitation: RequestSolicitationsService,
    private readonly _router: Router,
    private readonly _navigation: NavigationService,
    private readonly _link: LinkupService,
    private readonly cps: CopyService,
  ) { 
    super(app, _link, "header")
  }

  /**
   * Función de Angular ejecutada una vez el componente sea cargado, carga las configuraciones del header
   *
   * *Angular function that is run when the component is loaded, loads header configuration*
   */
  async ngOnInit() {
    this.setHeaderClass();
    this.closeText = "Salir";
    await super.loadStaticValues();
    this.CONTENT_BOUNDS = await this.cps.getCopy("header");
    if(!this.headerTitle){
      this.headerTitle = getValueProperty(this.CONTENT_BOUNDS, 'title');
    }
    
    if(!this.headerSubtitle){
      this.headerSubtitle = getValueProperty(this.CONTENT_BOUNDS, 'subtitle');
    }
    
  }
  setHeaderClass() {
    this.headerClass = 'portal-header';//this.channel.channelId === CHANNEL.PORTALPN.CODE ? 'transparent-header' : 'portal-header';
  }

  /**
   * Función para salir de la pantalla actual, si aplica
   *
   * *Function that exits current screen*
   */
  closeApp() {
    let eventSetting = this.getSetting("analytics", "trackEvent.e3", "");
    setValueProperty(eventSetting, "label", EVENT.E1customLabel);
    let events = [
      {
          "name": "{EVENT.E1setData.E1transactionName.path}",
          "value": EVENT.E1setData.E1transactionName.value
      }
    ]; 
    setValueProperty(eventSetting, "events", events);
    this.onEvent(eventSetting);    
    this.dialogShow = true;
    centerDialog();
  }

  /**
   * Pruebas confirm close
   */
  confirmClose(action: string) {
    this.dialogShow = false;
    if (action === this.ACTIONS_DIALOG.CONFIRM) {
      this._solicitation.reset();
      this._navigation.startFlow();
      /**if (this.app.channelId === '159') {
        this._router.navigate(['/default'], { skipLocationChange: true })
          .then(() => {
            this._router.navigate(['/solicitation-start']);
          });
      }
      else {
        if (this.app.currentApplication === 'fiducial') {
          this._router.navigate(['/default'], { skipLocationChange: true })
          .then(() => {
            this._router.navigate(['/requirements-start']);
          });
        }
        else {
          this._router.navigate(['/default'], { skipLocationChange: true })
          .then(() => {
            this._router.navigate(['/bank-start']);
          });
        }
      }*/
    }
    let eventSetting = this.getSetting("analytics", "trackEvent.e4", "");
    setValueProperty(eventSetting, "label", EVENT.E2customLabel+(action==this.ACTIONS_DIALOG.CONFIRM?"Aceptar":"Cancelar"));
    let events = [
      {
          "name": "{EVENT.E2setData.E2transactionName.path}",
          "value": EVENT.E2setData.E2transactionName.value
      }
    ]; 
    setValueProperty(eventSetting, "events", events);
    this.onEvent(eventSetting);    
    this.closeEvent.emit();
  }

  /**
   * Cambio de tab
   */
  confirmNavigate(action: string) {
    this.dialogChangeShow = false;
    scrollTop();
    if (action === this.ACTIONS_DIALOG.CONFIRM) {
      this.currentTab = this.selectedTab;
      this._solicitation.reset();
      if (this.currentTab == 1) {           
        if (this.app.channelId === '159') {
          this._navigation.startFlow();
        }
        else {
          this._navigation.startFlow().then(()=>{
            this._navigation.nextStep();
          });
        }
      } else {
        this._navigation.startFlow('solicitationSearch');              
      }
      let eventSetting = this.getSetting("analytics", "trackEvent.e6", "");
      setValueProperty(eventSetting, "label", EVENT.E4customLabel+"Aceptar");
      let pageSetting = this.getSetting("analytics", "pageLoad", "");
      let events = [
        {
            "name": "{EVENT.E4setData.E4transactionName.path}",
            "value": EVENT.E4setData.E4transactionName.value
        },
        {
          "name": "{EVENT.E4setData.E4transactionProductCategory.path}",
          "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
        }
      ]; 
      setValueProperty(eventSetting, "events", events);
      this.onEvent(eventSetting);     
      
    } else {
      //this.tabsComponent.tabSelected = `${this.currentTab}`;
      this.tabsComponent.current = this.currentTab;      
      let eventSetting = this.getSetting("analytics", "trackEvent.e6", "");
      let pageSetting = this.getSetting("analytics", "pageLoad", "");
      let events = [
        {
            "name": "{EVENT.E4setData.E4transactionName.path}",
            "value": EVENT.E4setData.E4transactionName.value
        },
        {
          "name": "{EVENT.E4setData.E4transactionProductCategory.path}",
          "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
        }
      ]; 
      setValueProperty(eventSetting, "events", events);
      setValueProperty(eventSetting, "label", EVENT.E4customLabel+"Cancelar");
      this.onEvent(eventSetting);          
    }
    this.closeEvent.emit();
  }

  tabsClick($event: any) {    
    this.dialogChangeShow = true;
    centerDialog();
    this.selectedTab = $event.current;
    let eventSetting = this.getSetting("analytics", "trackEvent.e1", "");
    let pageSetting = this.getSetting("analytics", "pageLoad", "");
    let events = [
      {
          "name": "{EVENT.E3setData.E3transactionName.path}",
          "value": EVENT.E3setData.E3transactionName.value
      },
      {
        "name": "{EVENT.E3setData.E3transactionProductCategory.path}",
        "value": getValueProperty(pageSetting, 'transaction.details.productcategory')
      }
    ]; 
    setValueProperty(eventSetting, "events", events);
    let tab = $event.current == 1? "Radicar": "Consultar";
    setValueProperty(eventSetting, "label", tab);
    this.onEvent(eventSetting);     
  }

  navigateFiducial() {
    this._solicitation.reset();
    this._router.navigate(['/fiducial']);
  }

}
